import { Component, effect, inject } from '@angular/core';
import { SigningFormsComponent } from '../../shared/signing-forms/signing-forms.component';
import { RoundIconComponent } from '../../shared/round-icon/round-icon.component';
import { IconNameType } from '../../shared/icons/icon-name-type.enum';
import { ModalName, ModalService } from '../services/modal.service';
import { TranslocoService } from '@ngneat/transloco';
import { AuditService } from '../services/audit.service';
import { A11yModule } from '@angular/cdk/a11y';

@Component({
  selector: 'cwo-signing-modal',
  standalone: true,
  imports: [SigningFormsComponent, RoundIconComponent, A11yModule],
  templateUrl: './signing-modal.component.html',
  styleUrl: './signing-modal.component.scss',
})
export class SigningModalComponent {
  iconNameType = IconNameType;
  modalService = inject(ModalService);
  translocoService = inject(TranslocoService);
  private auditService = inject(AuditService);
  activeTab = 'Sign In';
  submitButton: string | undefined;
  title?: string;
  modalName = ModalName;

  constructor() {
    effect(() => {
      const singInModalState = this.modalService.stateForModal(
        ModalName.SignIn
      );
      if (singInModalState) {
        this.submitButton = singInModalState?.submitButton || 'Sign In';
        this.activeTab = singInModalState?.activeTab || 'Sign In';
        this.title = singInModalState?.title || 'Sign In';
      }
    });
  }

  activePageChange(value: string) {
    this.activeTab = value;
  }

  getMessage() {
    if (this.modalService.stateForModal(ModalName.SignIn)?.showSubtitle) {
      if (this.activeTab === 'Sign In') {
        return this.translocoService.translate(
          'shared_components.signing_forms.login_form.sign_in_message'
        );
      } else {
        return this.translocoService.translate(
          'shared_components.signing_forms.registration_form.sign_up_message'
        );
      }
    }
    return undefined;
  }
}
